module.exports = __webpack_public_path__ + "static/img/2.897dd89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/eng/2.png
// module id = u8Y/
// module chunks = 0